module.exports = __webpack_public_path__ + "img/product6.6b567f1d.png";